import React, { useState } from 'react';
import { BLOG_POSTS } from '../constants/data';

const Blog = () => {
  const [openId, setOpenId] = useState(null);

  const toggle = (id) => setOpenId((current) => (current === id ? null : id));

  return (
    <section id="blog" className="section blog reveal">
      <div className="container">
        <div className="section-head">
          <span className="section-head__index">04</span>
          <h2 className="section-head__title">Writing</h2>
        </div>

        <div className="blog__list">
          {BLOG_POSTS.map((post) => {
            const isOpen = openId === post.id;
            return (
              <article key={post.id} className={`blog-post ${isOpen ? 'is-open' : ''}`}>
                <div className="blog-post__head">
                  <div className="blog-post__meta">
                    <span className="blog-post__date">{post.date}</span>
                    <div className="blog-post__tags">
                      {post.tags.map((tag) => (
                        <span key={tag} className="chip chip--sm">
                          {tag}
                        </span>
                      ))}
                    </div>
                  </div>
                  <h3 className="blog-post__title">{post.title}</h3>
                  <p className="blog-post__excerpt">{post.excerpt}</p>
                  <button
                    className="blog-post__toggle"
                    onClick={() => toggle(post.id)}
                    aria-expanded={isOpen}
                    aria-controls={`blog-post-${post.id}`}
                  >
                    {isOpen ? '− Close' : '+ Read article'}
                  </button>
                </div>

                {isOpen && (
                  <div id={`blog-post-${post.id}`} className="blog-post__content">
                    {post.content.map((paragraph, i) => (
                      <p key={i}>{paragraph}</p>
                    ))}
                  </div>
                )}
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Blog;
